import { forwardRef, HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type ScrollIconProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme: WPPageData['acf']['hero']['theme']
  }>

const ScrollIcon = forwardRef<HTMLDivElement, ScrollIconProps>(
  ({ className, theme, ...props }, ref) => {
    const loop = useRef<HTMLSpanElement>(null)

    useGSAP(
      () => {
        gsap.to(loop.current, {
          keyframes: {
            '0%': { scaleY: 0, yPercent: 0 },
            '50%': { scaleY: 1, yPercent: 0, ease: 'power1.inOut' },
            '75%': { scaleY: 1, yPercent: 0 },
            '100%': { scaleY: 0, yPercent: 100, ease: 'power1.inOut' },
            easeEach: 'none'
          },
          transformOrigin: 'top center',
          repeatDelay: 0.2,
          duration: 1.2,
          repeat: -1
        })

        return () => {
          gsap.killTweensOf(loop.current)
        }
      },
      { revertOnUpdate: true }
    )

    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center space-y-[2rem] md:space-y-[3rem]',
          className
        )}
        {...props}
      >
        <span
          ref={loop}
          className={cn(
            'relative block h-[3rem] w-[2px]',
            {
              'bg-black': theme === 'light',
              'bg-white': theme === 'dark' || theme === 'onyx'
            },
            className
          )}
        />
      </div>
    )
  }
)

export default ScrollIcon
